import React from 'react'
import { useLottie } from "lottie-react";
import animationData from './PinShield.json';

export default function PinShield() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
      const { View } = useLottie(defaultOptions);
      return (
        <div style={{ width: "100px", height: "30px" }} >
          {View}
        </div>
      );
  }
